import React, {useState} from 'react';
import {Button} from 'antd';

const SaveButtonComponent = React.memo(() => {
	const [saveButton, setSaveButton] = useState(false);
	return (
		<>
			<Button
				type="primary"
				htmlType="submit"
				onClick={() => {
					setTimeout(() => {
						setSaveButton(true);
					}, 500);
				}}
				disabled={saveButton}
			>
				保存
			</Button>
			<Button
				type="danger"
				htmlType="button"
				onClick={() => {
					window.history.back();
				}}
				style={{marginLeft: 8}}
			>
				返回
			</Button>
		</>
	);
});

export default SaveButtonComponent;
